import dynamic from 'next/dynamic';
import React, { useState } from 'react';

import { useBooleanFlags } from '@/domains/core/flags/flags.hooks';
import { Button } from '@/domains/core/tamagoshiv2/components/Button/Button';
import type { EconomicOperatorModalProps } from '@/productDiscovery/EconomicOperatorDisclaimer/types';

import { economicOperatorDisclaimerTitle } from './translations';

import styles from './EconomicOperatorDisclaimer.module.scss';

const EconomicOperatorModal = dynamic<EconomicOperatorModalProps>(
  () =>
    import('./EconomicOperatorModal').then((mod) => mod.EconomicOperatorModal),
  {
    ssr: false,
  },
);
export const EconomicOperatorDisclaimer = () => {
  const [showEconomicOperatorDisclaimer] = useBooleanFlags([
    'economicOperatorDisclaimer',
  ]);
  const [isVisible, setVisible] = useState(false);

  const openModal: () => void = () => {
    setVisible(true);
  };

  const hideModal = () => {
    setVisible(false);
  };
  if (!showEconomicOperatorDisclaimer) return null;

  return (
    <>
      <Button
        className={styles.disclaimer}
        onClick={openModal}
        type="link"
        width="fillContainer"
        content={economicOperatorDisclaimerTitle}
      />

      {isVisible && <EconomicOperatorModal hideModal={hideModal} />}
    </>
  );
};
